import Cookies from 'universal-cookie';
export function getAnonymousId() {
  const cookies = new Cookies();
  const anonymousId = cookies.get('ajs_anonymous_id', {
    doNotParse: true
  });
  return anonymousId;
}